import { PuffLoader } from "react-spinners";

export function Spinner() {
  return (
    <div className="flex items-center justify-center h-full">
      <PuffLoader color="#FE3448" size={60} />
    </div>
  );
}